<!-- <div class="text-center rounded-md align-template" [class.alertSuccess]="success" [class.alertFail]="failure"
    [class.alertWarning]="warning">
    <ng-content></ng-content>
</div> -->

<div *ngIf="manualCloser" [ngClass]="{'fade-out': fadeOutTrigger}" class="text-center rounded-md align-template"
    [class.alertSuccess]="success" [class.alertFail]="failure" [class.alertWarning]="warning">
    <div class="toaster-content">
        <ng-content></ng-content>
        <span *ngIf="failure" class="modal-close" (click)="closeToast()">✖</span>
    </div>
</div>